import { Typography } from "@mui/material";
import { MdOutlineUpdate } from "react-icons/md";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "config";

const ProjectLastUpdatedOn = ({ date }) => {
    if (!date) return null;
    

    return (
        <Typography
            sx={{
                fontSize: '14px',
                fontWeight: 400,
                color: '#858EA0',
                lineHeight: '100%',
                letterSpacing: '-0.4px',
                display: "flex",
                alignItems: "center",
                gap: "6px",
                whiteSpace: "nowrap",
            }}
        >
            <MdOutlineUpdate size={18} />
            Data as of {moment(date).format(DEFAULT_DATE_FORMAT)}
        </Typography>
    );
};

export default ProjectLastUpdatedOn;
